import usePageTracking from "./usePageTracking";

function PageTracker() {
  usePageTracking(); // ✅ This will safely call useLocation()
  return null; // No UI, just behavior
}

export default PageTracker;